import React from 'react';

import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import { SymbolInfoCapsuleConfigState } from 'widgets/symbolInfo/capsule/store/config/SymbolInfoCapsuleConfigState';
import { useSymbolInfoCapsuleConfigSlice } from 'widgets/symbolInfo/capsule/store/config/configSlice';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const SymbolInfoCapsuleSettingsText = `Symbol Info Capsule Settings`;

export interface SymbolInfoCapsuleSettingsProps {
    config?: SymbolInfoCapsuleConfigState;
    onChange?: (nextDelta: Partial<SymbolInfoCapsuleConfigState>) => void;
}

export default function SymbolInfoCapsuleSettings(
    props: SymbolInfoCapsuleSettingsProps
) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useSymbolInfoCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="SymbolInfoCapsuleSettings">
            <CapsuleSettingsSymbolEditor
                config={config}
                onChange={debouncedApplyWidgetConfigChange}
                group={true}
            />

            <WidgetNewportAppSettingsEditor
                specifyVisibleControls={{
                    showTooltips: false,
                    showChartHelp: true,
                    symbology: true,
                }}
            />
        </div>
    );
}
